// extracted by mini-css-extract-plugin
export var input = "form-module--input--lhjoE";
export var textArea = "form-module--text-area--a66ef";
export var label = "form-module--label--UAvWE";
export var note = "form-module--note--89Q1J";
export var errorMessage = "form-module--error-message--Z6RkV";
export var button = "form-module--button---Pf1P";